import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../Network/API";
import { useDispatch, useSelector } from "react-redux";
import { ADD_MESSAGE_SUCCESS, DELETE_TEMP_MESSAGE, INBOX_FETCH_SUCCESS } from "../Reducer/userInboxSlice";
import ContentLoader from "react-content-loader";
import toast from "react-hot-toast";
import UserAvatar from "../components/UserAvatar";

export default function ChatBody() {
  const [demo_data] = useState([{ id: 1 }, { id: 2 }, { id: 3 }]);
  const { user, accessToken } = useSelector((state) => state.authReducer);
  const data = useSelector((state) => state.userInboxReducer);
  const prams = useParams();
  const [isLoading, setLoading] = useState(false);
  const [isLoad, setLoad] = useState(false);
  const messagesEndRef = useRef(null);
  const [to_user, setUser] = useState();
  const [text, setText] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true)
    API.get(`/v1/oauth/get-conversation/${prams.id}`).then((response) => {
      setLoading(false)
      dispatch(INBOX_FETCH_SUCCESS(response.data.data))
      setUser(response.data.data.user)
    }).catch((error) => {
      setLoading(false)
    });
  }, [prams.id]);

  const scrollToBottom = (behavior = "smooth") => {
    messagesEndRef.current?.scrollIntoView({ behavior, block: "end", inline: "nearest" })
  }

  // keep the view pinned to the latest message
  useEffect(() => {
    scrollToBottom(isLoading ? "auto" : "smooth");
  }, [data?.messsage?.length, isLoading]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!text || !text.trim()) {
      toast.error("Message is empty");
      return false;
    }

    setLoad(true)
    const fd = new FormData();
    fd.append('to_id', to_user?.id);
    fd.append('message', text);
    const payload = {
      temp_id: to_user?.id,
      from_id: user.id,
      to_id: to_user?.id,
      seen_at: null,
      message: text,
      sender: { name: user.name, avatar: user.avatar },
      created_at: "1s ago"
    }
    dispatch(ADD_MESSAGE_SUCCESS(payload))

    API.post("/v1/oauth/send_message", fd, {}).then((response) => {
      setLoad(false)
      dispatch(DELETE_TEMP_MESSAGE(to_user?.id))
      dispatch(ADD_MESSAGE_SUCCESS(response.data.data.message))
    })
      .catch((err) => {
        setLoad(false)
      });

    setText('');
    event.target.reset();

    scrollToBottom();
  }

  const onComposerKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      e.target.form.requestSubmit();
    }
  }

  return (
    <>
      <div className="chat-about border-bottom pb-2 mb-2">
        <div className="d-flex align-items-center">
          <div className="chat-about-left me-2">
            <UserAvatar src={to_user?.avatar} name={to_user?.name} size={40} />
          </div>
          <div className="chat-about-right">
            <h6 className="mb-0">{to_user?.name}</h6>
            <small className="d-none">{to_user?.last_seen}</small>
          </div>
        </div>
      </div>
      <div className="pt-3 pe-3 user-chat-area" style={{ position: 'relative', height: '400px' }}>

        {isLoading && demo_data?.map((post, index) => (
          <div key={index}>
            <div className="d-flex flex-row justify-content-start">
              <ContentLoader
                speed={2}
                width={400}
                height={80}
                viewBox="0 0 400 80"
                backgroundColor="#eeecec"
                foregroundColor="#eae6e6"
              >
                <circle cx="37" cy="47" r="17" />
                <rect x="65" y="36" rx="0" ry="0" width="239" height="8" />
                <rect x="66" y="50" rx="0" ry="0" width="198" height="7" />
              </ContentLoader>
            </div>
            <div className="d-flex flex-row justify-content-end">
              <ContentLoader
                speed={2}
                width={400}
                height={80}
                viewBox="0 0 400 80"
                backgroundColor="#eeecec"
                foregroundColor="#eae6e6"
              >
                <circle cx="37" cy="47" r="17" />
                <rect x="65" y="36" rx="0" ry="0" width="239" height="8" />
                <rect x="66" y="50" rx="0" ry="0" width="198" height="7" />
              </ContentLoader>
            </div>
          </div>
        ))}

        {!isLoading && data?.messsage?.length > 0 && data?.messsage?.map((message, i) => (
          message?.to_id != to_user?.id ?
            <div className="d-flex flex-row justify-content-start chat-row" key={i}>
              <div className="flex-shrink-0 me-2">
                <UserAvatar src={to_user?.avatar} name={to_user?.name} size={36} />
              </div>
              <div className="chat-col">
                <p className="chat-bubble chat-bubble-in mb-1">{message?.message}</p>
                <p className="chat-time mb-3">{message?.time} · {message?.date}</p>
              </div>
            </div>
            :
            <div className="d-flex flex-row justify-content-end chat-row" key={i}>
              <div className="chat-col text-end">
                <p className="chat-bubble chat-bubble-out mb-1">{message?.message}</p>
                <p className="chat-time mb-3">{message?.time} · {message?.date}</p>
              </div>
              <div className="flex-shrink-0 ms-2">
                <UserAvatar src={message?.sender?.avatar} name={message?.sender?.name} size={36} />
              </div>
            </div>
        ))}
        <div className="messageEndArea" ref={messagesEndRef} />
      </div>
      <form method="post" onSubmit={handleSubmit}>
        <div className="chat-composer d-flex align-items-center pe-3 pt-3 mt-2">
          <UserAvatar src={user?.avatar} name={user?.name} size={36} />
          <textarea
            rows={1}
            value={text ?? ''}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={onComposerKeyDown}
            className="form-control chat-composer-input ms-2"
            placeholder="Type a message…"
          />
          <button type="submit" className="chat-send-btn ms-2" title="Send" disabled={isLoad}>
            <i className="fas fa-paper-plane" />
          </button>
        </div>
      </form>
    </>
  )
}
